export const isFeedbackSidebarFormVisible = (state) => {
  return state.feedback.isFeedbackSidebarFormVisible
}
